unit uSolicitudDwk;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, WEBLib.CDS, WEBLib.REST,
  Vcl.Controls, Vcl.Grids, WEBLib.DBCtrls, WEBLib.JSON,
  WEBLib.StdCtrls, System.Variants, Variants,
  WEBLib.ExtCtrls, Vcl.Imaging.jpeg,
  WEBLib.ComCtrls, WEBLib.Buttons, Vcl.StdCtrls, Vcl.Graphics,
  Vcl.Imaging.pngimage, WEBLib.Calendar, WebLib.Utils, WEBLib.JQCtrls,
  System.DateUtils;

type
  TFSolicitudDwk = class(TForm)
    WebPanel2: TPanel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebDBEdit4: TDBEdit;
    WebDBEdit1: TDBEdit;
    WebDBEdit2: TDBEdit;
    WebDBEdit5: TDBEdit;
    WebDBEdit6: TDBEdit;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    WebDateTimePicker2: TDateTimePicker;
    WebDBEdit3: TDBEdit;
    WebDateTimePicker1: TDateTimePicker;
    WebLabel1: TLabel;
    WebDBEdit8: TDBEdit;
    WebLabel2: TLabel;
    WebDBEdit9: TDBEdit;
    WebLabel12: TLabel;
    WebDBEdit10: TDBEdit;
    WebLabel13: TLabel;
    WebDBEdit11: TDBEdit;
    WebDBEdit12: TDBEdit;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    WebDBEdit13: TDBEdit;
    WebLabel16: TLabel;
    WebPanel1: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebDBGrid1: TDBGrid;
    WebDBCheckBox1: TDBCheckBox;
    WebPanel3: TPanel;
    WebEdit2: TEdit;
    WebDBNavigator1: TDBNavigator;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebPanel4: TPanel;
    WebLabel18: TLabel;
    WebDBGrid3: TDBGrid;
    WebEdit4: TEdit;
    WebSpeedButton8: TSpeedButton;
    WebSpeedButton9: TSpeedButton;
    WebDBGrid2: TDBGrid;
    CSolicitudHdr: TClientConnection;
    TSolicitudHdr: TClientDataSet;
    DsSolicitudHdr: TDataSource;
    WebCheckBox1: TCheckBox;
    WebCheckBox2: TCheckBox;
    WebCheckBox3: TCheckBox;
    WebCheckBox4: TCheckBox;
    WebCheckBox5: TCheckBox;
    WebCheckBox6: TCheckBox;
    WebLabel9: TLabel;
    WebDBEdit7: TDBEdit;
    CSolicitudDet: TClientConnection;
    TSolicitudDet: TClientDataSet;
    DsSolicitudDet: TDataSource;
    WebSpeedButton10: TSpeedButton;
    CEntrenaDoc: TClientConnection;
    TEntrenaDoc: TClientDataSet;
    DsEntrenaDoc: TDataSource;
    WebLabel10: TLabel;
    WebDBEdit14: TDBEdit;
    CEmpleados: TClientConnection;
    TEmpleados: TClientDataSet;
    WebHttpRequest1: THttpRequest;
    WebSpeedButton11: TSpeedButton;
    WebPanel5: TPanel;
    WebLabel11: TLabel;
    WebDBGrid4: TDBGrid;
    WebEdit1: TEdit;
    WebSpeedButton7: TSpeedButton;
    WebSpeedButton12: TSpeedButton;
    DsEmpleados: TDataSource;
    WebSpeedButton13: TSpeedButton;
    WebEdit3: TEdit;
    WebProgressBar1: TProgressBar;
    WebLabel17: TLabel;
    CDeptos: TClientConnection;
    TDeptos: TClientDataSet;
    DsDeptos: TDataSource;
    WebPanel6: TPanel;
    WebLabel19: TLabel;
    WebDBGrid5: TDBGrid;
    WebEdit5: TEdit;
    WebSpeedButton14: TSpeedButton;
    WebSpeedButton15: TSpeedButton;
    WebButton1: TButton;
    WebSpeedButton16: TSpeedButton;
    WebEdit6: TEdit;
    WebSpeedButton17: TSpeedButton;
    WebSpeedButton18: TSpeedButton;
    CPuestos: TClientConnection;
    TPuestos: TClientDataSet;
    DsPuestos: TDataSource;
    WebPanel7: TPanel;
    WebLabel20: TLabel;
    WebDBGrid6: TDBGrid;
    WebEdit7: TEdit;
    WebSpeedButton19: TSpeedButton;
    WebSpeedButton20: TSpeedButton;
    procedure WebFormCreate(Sender: TObject);
    procedure CSolicitudHdrAfterConnect(Sender: TObject);
    procedure WebSpeedButton10Click(Sender: TObject);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure DsSolicitudHdrDataChange(Sender: TObject; Field: TField);
    procedure WebDBEdit1Enter(Sender: TObject);
    procedure WebSpeedButton8Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebSpeedButton9Click(Sender: TObject);
    procedure WebDBGrid3DblClick(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure CSolicitudDetAfterConnect(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebSpeedButton11Click(Sender: TObject);
    procedure WebSpeedButton12Click(Sender: TObject);
    procedure CEntrenaDocAfterConnect(Sender: TObject);
    procedure WebDBGrid4DblClick(Sender: TObject);
    procedure WebSpeedButton13Click(Sender: TObject);
    procedure WebEdit3Enter(Sender: TObject);
    procedure WebSpeedButton14Click(Sender: TObject);
    procedure WebSpeedButton15Click(Sender: TObject);
    procedure CDeptosAfterConnect(Sender: TObject);
    procedure WebDBGrid5DblClick(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebSpeedButton16Click(Sender: TObject);
    procedure CEmpleadosAfterConnect(Sender: TObject);
    procedure WebHttpRequest1Response(Sender: TObject; AResponse: string);
    procedure WebEdit6Enter(Sender: TObject);
    procedure WebDBGrid6DblClick(Sender: TObject);
    procedure WebSpeedButton19Click(Sender: TObject);
    procedure WebSpeedButton20Click(Sender: TObject);
    procedure WebSpeedButton17Click(Sender: TObject);
    procedure WebSpeedButton18Click(Sender: TObject);
    procedure CPuestosAfterConnect(Sender: TObject);
    procedure WebDateTimePicker1Enter(Sender: TObject);
  private
    { Private declarations }
    procedure DesactivaCaptura;
    procedure DesactivaTODO;
    procedure ActivaCaptura;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

  type
  TProcedureRef = reference to procedure;

var
  FSolicitudDwk: TFSolicitudDwk;
  B1 : Integer;
  MOpcion, MBandera:String;
  MDocumento, MAgrega:String;

implementation

uses uMenu;

{$R *.dfm}

procedure SleepAsync(Milliseconds: Integer; AProc: TProcedureRef);
begin
  asm
    setTimeout(function() {
    AProc();
     }, Milliseconds);
  end;
end;

procedure TFSolicitudDwk.CDeptosAfterConnect(Sender: TObject);
begin
WebSpeedButton14.Visible:=True;
WebDBGrid5.Enabled:=True;
end;

procedure TFSolicitudDwk.CEmpleadosAfterConnect(Sender: TObject);
var
  Data: TJSONObject;
begin
  SleepAsync(300,
    procedure
    begin
      if TEmpleados.FieldByName('Numero').AsString = '' then
      begin
        ShowMessage('Error, Empleado no registrado!!');
        //WebLabel17.Caption := 'Empleado no registrado!!';
        Exit;
      end;
      //WebLabel17.Caption := 'Empleado: ' + TEmpleados.FieldByName
        //('Nombre').AsString;
      //WebLabel17.Visible := True;

    if MBandera = 'Depto' then
      begin
        {WebProgressBar1.Max:=TEmpleados.RecordCount;
        TEmpleados.First;
        while not TEmpleados.Eof do
        begin
          Data := TJSONObject.Create;
          try
            Data.AddPair('Numero', TEmpleados.FieldByName('Numero').AsString);
            Data.AddPair('EmpNombre', TEmpleados.FieldByName('Nombre2')
              .AsString);
            Data.AddPair('EmpPaterno', TEmpleados.FieldByName('Paterno')
              .AsString);
            Data.AddPair('EmpMaterno', TEmpleados.FieldByName('Materno')
              .AsString);
            Data.AddPair('Folio', WebDBEdit8.Text);
            Data.AddPair('Puesto', TEmpleados.FieldByName('Puesto').AsString);
            Data.AddPair('PuestoNombre', '');
            Data.AddPair('Depto', TEmpleados.FieldByName('Depto').AsString);
            Data.AddPair('DeptoNombre', '');

            WebHttpRequest1.URL := 'http://207.244.241.82:9000/SolicitudDet';
            WebHttpRequest1.Headers.Clear;
            WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
            WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
            WebHttpRequest1.Command := httpPOST;
            WebHttpRequest1.PostData := Data.ToJSON;

            WebHttpRequest1.Execute;
          finally
            Data.Free;
          end;
        WebProgressBar1.Position:=TEmpleados.RecNo;
        TEmpleados.Next;
        end;
        SleepAsync(300,
          procedure
          begin
            TSolicitudDet.Refresh;
          end);                     }
      end;


    end);

end;

procedure TFSolicitudDwk.CEntrenaDocAfterConnect(Sender: TObject);
begin
if MAgrega = 'SI' then
  begin
    TSolicitudHdr.Insert;
    ActivaCaptura;
    MOpcion := 'Inserta';
    B1 := 1;

    TEntrenaDoc.Locate('Codigo', MDocumento, []);
    WebDBEdit1.Text := TEntrenaDoc.FieldByName('Codigo').AsString;
    WebDBEdit2.Text := TEntrenaDoc.FieldByName('Descripcion').AsString;
    WebDBEdit5.Text := TEntrenaDoc.FieldByName('Revision').AsString;
    WebDBEdit6.Text := TEntrenaDoc.FieldByName('DuracionH').AsString + 'HRS ' +
      TEntrenaDoc.FieldByName('DuracionM').AsString + 'MIN';
    WebDBEdit7.Text := TEntrenaDoc.FieldByName('DuracionH').AsString + 'HRS ' +
      TEntrenaDoc.FieldByName('DuracionM').AsString + 'MIN';
  end;
end;

procedure TFSolicitudDwk.CPuestosAfterConnect(Sender: TObject);
begin
WebSpeedButton19.Visible:=True;
WebDBGrid6.Enabled:=True;
end;

procedure TFSolicitudDwk.CSolicitudDetAfterConnect(Sender: TObject);
begin
if B1 = 1 then Exit;

DesactivaCaptura;

end;

procedure TFSolicitudDwk.CSolicitudHdrAfterConnect(Sender: TObject);
begin
{CSolicitudDet.Command := httpGET;
CSolicitudDet.URI := 'http://207.244.241.82:9000/SolicitudDet?Folio=' +
  TSolicitudHdr.FieldByName('Folio').AsString;
CSolicitudDet.Active := True; }

end;

procedure TFSolicitudDwk.DsSolicitudHdrDataChange(Sender: TObject;
  Field: TField);
begin
if B1 = 1 then Exit;

CSolicitudDet.Command := httpGET;
CSolicitudDet.URI := 'http://207.244.241.82:9000/SolicitudDet?Folio=' +
  TSolicitudHdr.FieldByName('Folio').AsString;
CSolicitudDet.Active := True;
DesactivaTodo;
if TSolicitudHdr.FieldByName('OnClass').AsString = 'X' then WebCheckBox1.Checked:= True;
if TSolicitudHdr.FieldByName('OnDem').AsString = 'X' then WebCheckBox2.Checked:= True;
if TSolicitudHdr.FieldByName('OnJob').AsString = 'X' then WebCheckBox3.Checked:= True;
if TSolicitudHdr.FieldByName('OnVideo').AsString = 'X' then WebCheckBox4.Checked:= True;
if TSolicitudHdr.FieldByName('OnSemin').AsString = 'X' then WebCheckBox5.Checked:= True;
if TSolicitudHdr.FieldByName('OnSelf').AsString = 'X' then WebCheckBox6.Checked:= True;
if TSolicitudHdr.FieldByName('OnClass').AsString <> 'X' then WebCheckBox1.Checked:= False;
if TSolicitudHdr.FieldByName('OnDem').AsString <> 'X' then WebCheckBox2.Checked:= False;
if TSolicitudHdr.FieldByName('OnJob').AsString <> 'X' then WebCheckBox3.Checked:= False;
if TSolicitudHdr.FieldByName('OnVideo').AsString <> 'X' then WebCheckBox4.Checked:= False;
if TSolicitudHdr.FieldByName('OnSemin').AsString <> 'X' then WebCheckBox5.Checked:= False;
if TSolicitudHdr.FieldByName('OnSelf').AsString <> 'X' then WebCheckBox6.Checked:= False;
end;

procedure TFSolicitudDwk.WebButton1Click(Sender: TObject);
var
  Data: TJSONObject;
begin
  Data := TJSONObject.Create;
  try
    Data.AddPair('Registro', TSolicitudDet.FieldByName('Registro').AsString);

    WebHttpRequest1.URL := 'http://207.244.241.82:9000/SolicitudDet';
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpDELETE;
    WebHttpRequest1.PostData := Data.ToJSON;
    WebHttpRequest1.Execute;
  finally
    Data.Free;
  end;
  SleepAsync(300,
    procedure
    begin
      TSolicitudDet.Refresh;
    end);
end;

procedure TFSolicitudDwk.WebDateTimePicker1Enter(Sender: TObject);
begin
if uMenu.MNivel <> '4' then
  begin
  WebDBEdit5.SetFocus;
  end;

end;

procedure TFSolicitudDwk.WebDBEdit1Enter(Sender: TObject);
begin
WebPanel4.Visible:=True;
WebPanel4.Top:=256;
WebPanel4.Left:=28;
end;

procedure TFSolicitudDwk.WebDBGrid3DblClick(Sender: TObject);
begin
WebPanel4.Visible:=False;
WebDBEdit1.Text:=TEntrenaDoc.FieldByName('Codigo').AsString;
WebDBEdit2.Text:=TEntrenaDoc.FieldByName('Descripcion').AsString;
WebDBEdit5.Text:=TEntrenaDoc.FieldByName('Revision').AsString;
WebDBEdit6.Text:=TEntrenaDoc.FieldByName('DuracionH').AsString + 'HRS '+
  TEntrenaDoc.FieldByName('DuracionM').AsString+'MIN';
WebDBEdit7.Text:=TEntrenaDoc.FieldByName('DuracionH').AsString + 'HRS '+
  TEntrenaDoc.FieldByName('DuracionM').AsString+'MIN';

end;

procedure TFSolicitudDwk.WebDBGrid4DblClick(Sender: TObject);
var
  Data: TJSONObject;
begin
Data := TJSONObject.Create;
  try
    Data.AddPair('Numero', TEmpleados.FieldByName('Numero').AsString);
    Data.AddPair('EmpNombre', TEmpleados.FieldByName('Nombre2').AsString);
    Data.AddPair('EmpPaterno', TEmpleados.FieldByName('Paterno').AsString);
    Data.AddPair('EmpMaterno', TEmpleados.FieldByName('Materno').AsString);
    Data.AddPair('Folio', WebDBEdit8.Text);
    Data.AddPair('Puesto', TEmpleados.FieldByName('Puesto').AsString);
    Data.AddPair('PuestoNombre', '');
    Data.AddPair('Depto', TEmpleados.FieldByName('Depto').AsString);
    Data.AddPair('DeptoNombre', '');

    WebHttpRequest1.URL := 'http://207.244.241.82:9000/SolicitudDet';
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpPOST;
    WebHttpRequest1.PostData := Data.ToJSON;

    WebHttpRequest1.Execute;

  finally
    Data.Free;
  end;

  SleepAsync(300,
      procedure
      begin
        TSolicitudDet.Refresh;
      end);
    ShowMessage('Empleado: ' + TEmpleados.FieldByName('Nombre2').AsString +
      ' Registrado correctamente');
end;

procedure TFSolicitudDwk.WebDBGrid5DblClick(Sender: TObject);
begin
WebEdit3.Text:=TDeptos.FieldByName('Clave').AsString;
WebPanel6.Visible:=False;
end;

procedure TFSolicitudDwk.WebDBGrid6DblClick(Sender: TObject);
begin
WebEdit6.Text:=TPuestos.FieldByName('Clave').AsString;
WebPanel7.Visible:=False;
end;

procedure TFSolicitudDwk.WebEdit3Enter(Sender: TObject);
begin
CDeptos.Command := httpGET;
CDeptos.URI := 'http://207.244.241.82:9000/Deptos';
CDeptos.Active := True;

WebPanel6.Visible:=True;

WebPanel6.Top:= 135;
WebPanel6.Left:= 336;
end;

procedure TFSolicitudDwk.WebEdit6Enter(Sender: TObject);
begin
CPuestos.Command := httpGET;
CPuestos.URI := 'http://207.244.241.82:9000/Puestos';
CPuestos.Active := True;

WebPanel7.Visible:=True;

WebPanel7.Top:= 135;
WebPanel7.Left:= 336;
end;

procedure TFSolicitudDwk.WebFormCreate(Sender: TObject);
begin
//ShowMessage(MDocumento+' '+MAgrega);

CSolicitudHdr.Command := httpGET;
CSolicitudHdr.URI := 'http://207.244.241.82:9000/SolicitudHdr?Abiertas=True';
CSolicitudHdr.Active := True;
CEntrenaDoc.Command := httpGET;
CEntrenaDoc.URI := 'http://207.244.241.82:9000/EntrenaDoc';
CEntrenaDoc.Active := True;

WebDateTimePicker1.Top := WebDBEdit3.Top;
WebDateTimePicker1.Left := WebDBEdit3.Left;
WebDateTimePicker1.Date := Now;
WebDateTimePicker1.Width := WebDBEdit3.Width;
WebDateTimePicker1.Height := WebDBEdit3.Height;

WebPanel5.Top:= 135;
WebPanel5.Left:= 336;

DesactivaTODO;
end;

procedure TFSolicitudDwk.WebHttpRequest1Response(Sender: TObject;
  AResponse: string);
begin
  if AResponse = 'Empleados insertados correctamente sin duplicados' then
  begin
    ShowMessage('Departamento agregado correctamente a la DWK!!');
    TSolicitudDet.Refresh;
  end;
  if AResponse = 'EmpleadosP insertados correctamente sin duplicados' then
  begin
    ShowMessage('Puesto agregado correctamente a la DWK!!');
    TSolicitudDet.Refresh;
  end;
  if AResponse = 'EmpleadosT insertados correctamente sin duplicados' then
  begin
    ShowMessage('Todos los empleados agregados correctamente a la DWK!!');
    TSolicitudDet.Refresh;
  end;
end;

procedure TFSolicitudDwk.WebSpeedButton10Click(Sender: TObject);
begin
FSolicitudDwk.Hide;
end;

procedure TFSolicitudDwk.WebSpeedButton11Click(Sender: TObject);
Var
Data: TJSONObject;
Folio, URL: string;
begin
Folio:=TSolicitudHdr.FieldByName('Folio').AsString;
URL := 'http://207.244.241.82:9000/PDFReporteDwk?FOLIO=' + Folio;
  asm
  window.open(URL, '_blank');
  end;


end;

procedure TFSolicitudDwk.WebSpeedButton12Click(Sender: TObject);
var
  Data: TJSONObject;
begin
{Data := TJSONObject.Create;
    try
      Data.AddPair('Codigo', WebDBEdit1.Text);



      ShowMessage('JSON a enviar:'#13#10#13#10 + Data.ToJSON);
      WebHttpRequest1.URL := 'http://207.244.241.82:9000/SolicitudHdr';
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
      WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
      WebHttpRequest1.Command := httpPUT;
      WebHttpRequest1.PostData := Data.ToJSON;

      WebHttpRequest1.Execute;

    finally
      Data.Free;
    end;  }
WebPanel5.Visible:=False;
end;

procedure TFSolicitudDwk.WebSpeedButton13Click(Sender: TObject);
begin
  // Asigna masivos
  //CEmpleados.Command := httpGET;
  //CEmpleados.URI := 'http://207.244.241.82:9000/Empleados?Depto=' +
  //  WebEdit3.Text;
  //CEmpleados.Active := True;
  //MBandera := 'Depto';
  // ShowMessage('Se están registrando empleados de forma masiva. ' + sLineBreak +
  // 'Por favor, espere a que la tabla inferior se cargue completamente antes de continuar.');
  WebHttpRequest1.URL := 'http://207.244.241.82:9000/SolicitudDetDepto?Folio=' +
    WebDBEdit8.Text + '&Depto=' + WebEdit3.Text;
  WebHttpRequest1.Headers.Clear;
  WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
  WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
  WebHttpRequest1.Command := httpPOST;
  WebHttpRequest1.Execute;
end;

procedure TFSolicitudDwk.WebSpeedButton14Click(Sender: TObject);
begin
TDeptos.Locate('Clave', WebEdit5.Text, []);
end;

procedure TFSolicitudDwk.WebSpeedButton15Click(Sender: TObject);
begin
WebPanel6.Visible:=False;
end;

procedure TFSolicitudDwk.WebSpeedButton16Click(Sender: TObject);
begin
TSolicitudHdr.Refresh;
end;

procedure TFSolicitudDwk.WebSpeedButton17Click(Sender: TObject);
begin
  WebHttpRequest1.URL := 'http://207.244.241.82:9000/SolicitudDetPuesto?Folio=' +
    WebDBEdit8.Text + '&Puesto=' + WebEdit6.Text;
  WebHttpRequest1.Headers.Clear;
  WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
  WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
  WebHttpRequest1.Command := httpPOST;
  WebHttpRequest1.Execute;
end;

procedure TFSolicitudDwk.WebSpeedButton18Click(Sender: TObject);
begin
 WebHttpRequest1.URL := 'http://207.244.241.82:9000/SolicitudDetTodos?Folio=' +
    WebDBEdit8.Text;
  WebHttpRequest1.Headers.Clear;
  WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
  WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
  WebHttpRequest1.Command := httpPOST;
  WebHttpRequest1.Execute;
end;

procedure TFSolicitudDwk.WebSpeedButton19Click(Sender: TObject);
begin
TPuestos.Locate('Clave', WebEdit7.Text, []);
end;

procedure TFSolicitudDwk.WebSpeedButton1Click(Sender: TObject);
var
  Data: TJSONObject;
begin
{  Data := TJSONObject.Create;
  try
    Data.AddPair('Numero', TEmpleados.FieldByName('Numero').AsString);
    Data.AddPair('EmpNombre', TEmpleados.FieldByName('Nombre2').AsString);
    Data.AddPair('EmpPaterno', TEmpleados.FieldByName('Paterno').AsString);
    Data.AddPair('EmpMaterno', TEmpleados.FieldByName('Materno').AsString);
    Data.AddPair('Folio', WebDBEdit8.Text);
    Data.AddPair('Puesto', TEmpleados.FieldByName('Puesto').AsString);
    Data.AddPair('PuestoNombre', '');
    Data.AddPair('Depto', TEmpleados.FieldByName('Depto').AsString);
    Data.AddPair('DeptoNombre', '');

    WebHttpRequest1.URL := 'http://207.244.241.82:9000/SolicitudDet';
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpPOST;
    WebHttpRequest1.PostData := Data.ToJSON;

    WebHttpRequest1.Execute;

  finally
    Data.Free;
  end;

  SleepAsync(300,
      procedure
      begin
        TSolicitudDet.Refresh;
      end); }
WebPanel5.Visible:=True;
end;

procedure TFSolicitudDwk.WebSpeedButton20Click(Sender: TObject);
begin
WebPanel7.Visible:=False;
end;

procedure TFSolicitudDwk.WebSpeedButton2Click(Sender: TObject);
var
  FechaInicio: TDateTime;
  Dias: Integer;
begin
 FechaInicio := StrToDate(TSolicitudHdr.FieldByName('FechaPedido').AsString);

  Dias := DaysBetween(Now, FechaInicio);

  if Dias >= 15 then
  begin
    ShowMessage
      ('Esta DWK no puede ser editada ya que esta fuera de periodo!!.');
    Exit;
  end;
TSolicitudHdr.Edit;
ActivaCaptura;
MOpcion:='Edita';
B1:=1;
end;

procedure TFSolicitudDwk.WebSpeedButton3Click(Sender: TObject);
begin
TSolicitudHdr.Insert;
ActivaCaptura;
MOpcion:='Inserta';
B1:=1;
end;

procedure TFSolicitudDwk.WebSpeedButton4Click(Sender: TObject);
begin
TSolicitudHdr.Cancel;
DesactivaCaptura;
B1:=0;
end;

procedure TFSolicitudDwk.WebSpeedButton5Click(Sender: TObject);
var
  Data: TJSONObject;
begin
  // TSolicitudHdr.Post;
  ShowMessage(MOpcion);
  B1 := 1;

  if MOpcion = 'Inserta' then
  begin
    Data := TJSONObject.Create;
    try
      Data.AddPair('Folio', WebDBEdit8.Text);
      Data.AddPair('Nombre', WebDBEdit9.Text);
      Data.AddPair('Nombre2', WebDBEdit10.Text);
      Data.AddPair('NoDocumento', WebDBEdit1.Text);
      Data.AddPair('Alcance', WebDBEdit14.Text);
      Data.AddPair('Depto', WebDBEdit11.Text);
      Data.AddPair('Depto2', WebDBEdit12.Text);
      Data.AddPair('Revision', WebDBEdit5.Text);
      Data.AddPair('Entrenamiento', WebDBEdit2.Text);
      Data.AddPair('FechaPedido', FormatDateTime('MM/DD/YYYY',
        WebDateTimePicker1.Date));
      Data.AddPair('AreaEntrena', WebDBEdit12.Text);
      Data.AddPair('Duracion', WebDBEdit6.Text);
      Data.AddPair('DuracionTotal', WebDBEdit7.Text);
      Data.AddPair('FechaFinalizada', FormatDateTime('MM/DD/YYYY',
        WebDateTimePicker2.Date));
      if WebCheckBox1.Checked = True then
        Data.AddPair('OnClass', 'X');
      if WebCheckBox2.Checked = True then
        Data.AddPair('OnDem', 'X');
      if WebCheckBox4.Checked = True then
        Data.AddPair('OnVideo', 'X');
      if WebCheckBox5.Checked = True then
        Data.AddPair('OnSemin', 'X');
      if WebCheckBox6.Checked = True then
        Data.AddPair('OnSelf', 'X');
      if WebCheckBox3.Checked = True then
        Data.AddPair('OnJob', 'X');
      Data.AddPair('OnOther', WebDBEdit13.Text);
      Data.AddPair('DocumentoNombre', WebDBEdit2.Text);

      WebHttpRequest1.URL := 'http://207.244.241.82:9000/SolicitudHdr';
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
      WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
      WebHttpRequest1.Command := httpPOST;
      WebHttpRequest1.PostData := Data.ToJSON;
      WebHttpRequest1.Execute;
    finally
      Data.Free;
    end;
  end;

  if MOpcion = 'Edita' then
  begin
    Data := TJSONObject.Create;
    try
      Data.AddPair('Registro', TSolicitudHdr.FieldByName('Registro').AsString);
      Data.AddPair('Folio', WebDBEdit8.Text);
      Data.AddPair('Nombre', WebDBEdit9.Text);
      Data.AddPair('Nombre2', WebDBEdit10.Text);
      Data.AddPair('NoDocumento', WebDBEdit1.Text);
      Data.AddPair('Alcance', WebDBEdit14.Text);
      Data.AddPair('Depto', WebDBEdit11.Text);
      Data.AddPair('Depto2', WebDBEdit12.Text);
      Data.AddPair('Revision', WebDBEdit5.Text);
      Data.AddPair('Entrenamiento', WebDBEdit2.Text);
      Data.AddPair('FechaPedido', FormatDateTime('MM/DD/YYYY',
        WebDateTimePicker1.Date));
      Data.AddPair('AreaEntrena', WebDBEdit12.Text);
      Data.AddPair('Duracion', WebDBEdit6.Text);
      Data.AddPair('DuracionTotal', WebDBEdit7.Text);
      Data.AddPair('FechaFinalizada', FormatDateTime('MM/DD/YYYY',
        WebDateTimePicker2.Date));
      if WebCheckBox1.Checked = True then
        Data.AddPair('OnClass', 'X');
      if WebCheckBox2.Checked = True then
        Data.AddPair('OnDem', 'X');
      if WebCheckBox4.Checked = True then
        Data.AddPair('OnVideo', 'X');
      if WebCheckBox5.Checked = True then
        Data.AddPair('OnSemin', 'X');
      if WebCheckBox6.Checked = True then
        Data.AddPair('OnSelf', 'X');
      if WebCheckBox3.Checked = True then
        Data.AddPair('OnJob', 'X');
      Data.AddPair('Onother', WebDBEdit13.Text);
      Data.AddPair('DocumentoNombre', WebDBEdit2.Text);

      WebHttpRequest1.URL := 'http://207.244.241.82:9000/SolicitudHdr';
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
      WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
      WebHttpRequest1.Command := httpPUT;
      WebHttpRequest1.PostData := Data.ToJSON;
      WebHttpRequest1.Execute;
    finally
      Data.Free;
    end;
  end;
  TSolicitudHdr.Post;
    SleepAsync(300,
    procedure
    begin
      TSolicitudHdr.Refresh;
    end);
  DesactivaCaptura;
  B1 := 0;
end;

procedure TFSolicitudDwk.WebSpeedButton6Click(Sender: TObject);
begin
TSolicitudHdr.Locate('Folio', WebEdit2.Text, []);
end;

procedure TFSolicitudDwk.WebSpeedButton7Click(Sender: TObject);
begin
//WebLabel17.Caption:='BUSCANDO EMPLEADO...';
  //WebLabel10.Visible := False;
  CEmpleados.Command := httpGET;
  CEmpleados.URI := 'http://207.244.241.82:9000/Empleados?Busqueda=' +
    WebEdit1.Text;
  CEmpleados.Active := True;
end;

procedure TFSolicitudDwk.WebSpeedButton8Click(Sender: TObject);
begin
TEntrenaDoc.Locate('Codigo', WebEdit4.Text, []);
end;

procedure TFSolicitudDwk.WebSpeedButton9Click(Sender: TObject);
begin
WebPanel4.Visible:=False;
end;

procedure TFSolicitudDwk.DesactivaCaptura;
begin
WebDBEdit1.Enabled:=False;
WebDBEdit2.Enabled:=False;
WebDBEdit3.Enabled:=False;
WebDBEdit4.Enabled:=False;
WebDBEdit5.Enabled:=False;
WebDBEdit6.Enabled:=False;
WebDBEdit7.Enabled:=False;
WebDBEdit8.Enabled:=False;
WebDBEdit9.Enabled:=False;
WebDBEdit10.Enabled:=False;
WebDBEdit11.Enabled:=False;
WebDBEdit12.Enabled:=False;
WebDBEdit13.Enabled:=False;
WebDBEdit14.Enabled:=False;
WebCheckBox1.Enabled:=False;
WebCheckBox2.Enabled:=False;
WebCheckBox3.Enabled:=False;
WebCheckBox4.Enabled:=False;
WebCheckBox5.Enabled:=False;
WebCheckBox6.Enabled:=False;
WebDBCheckBox1.Enabled:=False;
WebDateTimePicker1.Visible:=False;
//WebDateTimePicker2.Visible:=False;
WebSpeedButton4.Visible:=False;
WebSpeedButton5.Visible:=False;

WebEdit2.Enabled:=True;
WebSpeedButton6.Enabled:=True;
WebDBNavigator1.Enabled:=True;
WebSpeedButton3.Enabled:=True;
WebSpeedButton2.Enabled:=True;
WebDBGrid2.Enabled:=True;
WebDBGrid1.Visible:=True;
WebPanel1.Visible:=True;
end;

procedure TFSolicitudDwk.DesactivaTodo;
begin
WebDBEdit1.Enabled:=False;
WebDBEdit2.Enabled:=False;
WebDBEdit3.Enabled:=False;
WebDBEdit4.Enabled:=False;
WebDBEdit5.Enabled:=False;
WebDBEdit6.Enabled:=False;
WebDBEdit7.Enabled:=False;
WebDBEdit8.Enabled:=False;
WebDBEdit9.Enabled:=False;
WebDBEdit10.Enabled:=False;
WebDBEdit11.Enabled:=False;
WebDBEdit12.Enabled:=False;
WebDBEdit13.Enabled:=False;
WebDBEdit14.Enabled:=False;
WebCheckBox1.Enabled:=False;
WebCheckBox2.Enabled:=False;
WebCheckBox3.Enabled:=False;
WebCheckBox4.Enabled:=False;
WebCheckBox5.Enabled:=False;
WebCheckBox6.Enabled:=False;
WebDBCheckBox1.Enabled:=False;
WebDateTimePicker1.Visible:=False;
//WebDateTimePicker2.Visible:=False;
WebSpeedButton4.Visible:=False;
WebSpeedButton5.Visible:=False;

WebEdit2.Enabled:=False;
WebSpeedButton6.Enabled:=False;
WebDBNavigator1.Enabled:=False;
WebSpeedButton3.Enabled:=False;
WebSpeedButton2.Enabled:=False;
WebDBGrid2.Enabled:=False;
WebDBGrid1.Visible:=False;
WebPanel1.Visible:=False;
end;

procedure TFSolicitudDwk.ActivaCaptura;
begin
WebDBEdit1.Enabled:=True;
WebDBEdit2.Enabled:=True;
WebDBEdit3.Enabled:=True;
WebDBEdit4.Enabled:=True;
WebDBEdit5.Enabled:=True;
WebDBEdit6.Enabled:=True;
WebDBEdit7.Enabled:=True;
WebDBEdit8.Enabled:=True;
WebDBEdit9.Enabled:=True;
WebDBEdit10.Enabled:=True;
WebDBEdit11.Enabled:=True;
WebDBEdit12.Enabled:=True;
WebDBEdit13.Enabled:=True;
WebDBEdit14.Enabled:=True;
WebCheckBox1.Enabled:=True;
WebCheckBox2.Enabled:=True;
WebCheckBox3.Enabled:=True;
WebCheckBox4.Enabled:=True;
WebCheckBox5.Enabled:=True;
WebCheckBox6.Enabled:=True;
//WebDBCheckBox1.Enabled:=True;
WebDateTimePicker1.Visible:=True;
//WebDateTimePicker2.Visible:=True;
WebSpeedButton4.Visible:=True;
WebSpeedButton5.Visible:=True;

WebEdit2.Enabled:=False;
WebSpeedButton6.Enabled:=False;
WebDBNavigator1.Enabled:=False;
WebSpeedButton3.Enabled:=False;
WebSpeedButton2.Enabled:=False;
WebDBGrid2.Enabled:=False;
WebDBGrid1.Visible:=False;
WebPanel1.Visible:=False;
end;


procedure TFSolicitudDwk.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel17 := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebDBEdit4 := TDBEdit.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  WebDBEdit5 := TDBEdit.Create(Self);
  WebDBEdit6 := TDBEdit.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebDateTimePicker2 := TDateTimePicker.Create(Self);
  WebDBEdit3 := TDBEdit.Create(Self);
  WebDateTimePicker1 := TDateTimePicker.Create(Self);
  WebDBEdit8 := TDBEdit.Create(Self);
  WebDBEdit9 := TDBEdit.Create(Self);
  WebDBEdit10 := TDBEdit.Create(Self);
  WebDBEdit11 := TDBEdit.Create(Self);
  WebDBEdit12 := TDBEdit.Create(Self);
  WebDBEdit13 := TDBEdit.Create(Self);
  WebDBCheckBox1 := TDBCheckBox.Create(Self);
  WebCheckBox1 := TCheckBox.Create(Self);
  WebCheckBox2 := TCheckBox.Create(Self);
  WebCheckBox3 := TCheckBox.Create(Self);
  WebCheckBox4 := TCheckBox.Create(Self);
  WebCheckBox5 := TCheckBox.Create(Self);
  WebCheckBox6 := TCheckBox.Create(Self);
  WebDBEdit7 := TDBEdit.Create(Self);
  WebDBEdit14 := TDBEdit.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton13 := TSpeedButton.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebSpeedButton17 := TSpeedButton.Create(Self);
  WebSpeedButton18 := TSpeedButton.Create(Self);
  WebDBGrid1 := TDBGrid.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebDBNavigator1 := TDBNavigator.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebDBGrid2 := TDBGrid.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebDBGrid3 := TDBGrid.Create(Self);
  WebEdit4 := TEdit.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebSpeedButton11 := TSpeedButton.Create(Self);
  WebPanel5 := TPanel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebDBGrid4 := TDBGrid.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  WebSpeedButton12 := TSpeedButton.Create(Self);
  WebProgressBar1 := TProgressBar.Create(Self);
  WebPanel6 := TPanel.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebDBGrid5 := TDBGrid.Create(Self);
  WebEdit5 := TEdit.Create(Self);
  WebSpeedButton14 := TSpeedButton.Create(Self);
  WebSpeedButton15 := TSpeedButton.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebSpeedButton16 := TSpeedButton.Create(Self);
  WebPanel7 := TPanel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebDBGrid6 := TDBGrid.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebSpeedButton19 := TSpeedButton.Create(Self);
  WebSpeedButton20 := TSpeedButton.Create(Self);
  CSolicitudHdr := TClientConnection.Create(Self);
  TSolicitudHdr := TClientDataSet.Create(Self);
  DsSolicitudHdr := TDataSource.Create(Self);
  CSolicitudDet := TClientConnection.Create(Self);
  TSolicitudDet := TClientDataSet.Create(Self);
  DsSolicitudDet := TDataSource.Create(Self);
  CEntrenaDoc := TClientConnection.Create(Self);
  TEntrenaDoc := TClientDataSet.Create(Self);
  DsEntrenaDoc := TDataSource.Create(Self);
  CEmpleados := TClientConnection.Create(Self);
  TEmpleados := TClientDataSet.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);
  DsEmpleados := TDataSource.Create(Self);
  CDeptos := TClientConnection.Create(Self);
  TDeptos := TClientDataSet.Create(Self);
  DsDeptos := TDataSource.Create(Self);
  CPuestos := TClientConnection.Create(Self);
  TPuestos := TClientDataSet.Create(Self);
  DsPuestos := TDataSource.Create(Self);

  WebLabel17.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebDBEdit5.BeforeLoadDFMValues;
  WebDBEdit6.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebDateTimePicker2.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  WebDateTimePicker1.BeforeLoadDFMValues;
  WebDBEdit8.BeforeLoadDFMValues;
  WebDBEdit9.BeforeLoadDFMValues;
  WebDBEdit10.BeforeLoadDFMValues;
  WebDBEdit11.BeforeLoadDFMValues;
  WebDBEdit12.BeforeLoadDFMValues;
  WebDBEdit13.BeforeLoadDFMValues;
  WebDBCheckBox1.BeforeLoadDFMValues;
  WebCheckBox1.BeforeLoadDFMValues;
  WebCheckBox2.BeforeLoadDFMValues;
  WebCheckBox3.BeforeLoadDFMValues;
  WebCheckBox4.BeforeLoadDFMValues;
  WebCheckBox5.BeforeLoadDFMValues;
  WebCheckBox6.BeforeLoadDFMValues;
  WebDBEdit7.BeforeLoadDFMValues;
  WebDBEdit14.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton13.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebSpeedButton17.BeforeLoadDFMValues;
  WebSpeedButton18.BeforeLoadDFMValues;
  WebDBGrid1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebDBNavigator1.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebDBGrid2.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebDBGrid3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebSpeedButton11.BeforeLoadDFMValues;
  WebPanel5.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebDBGrid4.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  WebSpeedButton12.BeforeLoadDFMValues;
  WebProgressBar1.BeforeLoadDFMValues;
  WebPanel6.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebDBGrid5.BeforeLoadDFMValues;
  WebEdit5.BeforeLoadDFMValues;
  WebSpeedButton14.BeforeLoadDFMValues;
  WebSpeedButton15.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebSpeedButton16.BeforeLoadDFMValues;
  WebPanel7.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebDBGrid6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebSpeedButton19.BeforeLoadDFMValues;
  WebSpeedButton20.BeforeLoadDFMValues;
  CSolicitudHdr.BeforeLoadDFMValues;
  TSolicitudHdr.BeforeLoadDFMValues;
  DsSolicitudHdr.BeforeLoadDFMValues;
  CSolicitudDet.BeforeLoadDFMValues;
  TSolicitudDet.BeforeLoadDFMValues;
  DsSolicitudDet.BeforeLoadDFMValues;
  CEntrenaDoc.BeforeLoadDFMValues;
  TEntrenaDoc.BeforeLoadDFMValues;
  DsEntrenaDoc.BeforeLoadDFMValues;
  CEmpleados.BeforeLoadDFMValues;
  TEmpleados.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  DsEmpleados.BeforeLoadDFMValues;
  CDeptos.BeforeLoadDFMValues;
  TDeptos.BeforeLoadDFMValues;
  DsDeptos.BeforeLoadDFMValues;
  CPuestos.BeforeLoadDFMValues;
  TPuestos.BeforeLoadDFMValues;
  DsPuestos.BeforeLoadDFMValues;
  try
    Name := 'FSolicitudDwk';
    Width := 1857;
    Height := 1013;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebLabel17.SetParentComponent(Self);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 904;
    WebLabel17.Top := 24;
    WebLabel17.Width := 91;
    WebLabel17.Height := 13;
    WebLabel17.Caption := 'DWK en proceso';
    WebLabel17.Font.Charset := DEFAULT_CHARSET;
    WebLabel17.Font.Color := clWindowText;
    WebLabel17.Font.Height := -11;
    WebLabel17.Font.Name := 'Tahoma';
    WebLabel17.Font.Style := [fsBold];
    WebLabel17.HeightPercent := 100.000000000000000000;
    WebLabel17.ParentFont := False;
    WebLabel17.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 16;
    WebPanel2.Top := 88;
    WebPanel2.Width := 497;
    WebPanel2.Height := 745;
    WebPanel2.HeightPercent := 100.000000000000000000;
    WebPanel2.WidthPercent := 100.000000000000000000;
    WebPanel2.BorderColor := clBlack;
    WebPanel2.BorderStyle := bsSingle;
    WebPanel2.ChildOrder := 4;
    WebPanel2.Color := clInfoBk;
    WebLabel3.SetParentComponent(WebPanel2);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 14;
    WebLabel3.Top := 158;
    WebLabel3.Width := 58;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Documento:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel2);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 14;
    WebLabel4.Top := 205;
    WebLabel4.Width := 58;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Descripci'#243'n:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel2);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 14;
    WebLabel5.Top := 252;
    WebLabel5.Width := 89;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'Fecha de solicitud:';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(WebPanel2);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 150;
    WebLabel6.Top := 252;
    WebLabel6.Width := 78;
    WebLabel6.Height := 13;
    WebLabel6.Caption := 'Fecha de cierre:';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.Visible := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebPanel2);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 14;
    WebLabel7.Top := 299;
    WebLabel7.Width := 44;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Revisi'#243'n:';
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(WebPanel2);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 14;
    WebLabel8.Top := 346;
    WebLabel8.Width := 132;
    WebLabel8.Height := 13;
    WebLabel8.Caption := 'Duraci'#243'n del entrenamiento';
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.Visible := False;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(WebPanel2);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 14;
    WebLabel1.Top := 17;
    WebLabel1.Width := 26;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Folio:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel2);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 14;
    WebLabel2.Top := 64;
    WebLabel2.Width := 53;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Solicitante:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel12.SetParentComponent(WebPanel2);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 14;
    WebLabel12.Top := 111;
    WebLabel12.Width := 126;
    WebLabel12.Height := 13;
    WebLabel12.Caption := 'Capacitador / Entrenador:';
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(WebPanel2);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 210;
    WebLabel13.Top := 64;
    WebLabel13.Width := 141;
    WebLabel13.Height := 13;
    WebLabel13.Caption := 'Departamento del solicitante:';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebLabel14.SetParentComponent(WebPanel2);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 210;
    WebLabel14.Top := 111;
    WebLabel14.Width := 213;
    WebLabel14.Height := 13;
    WebLabel14.Caption := 'Departamento del capacitador / entrenador:';
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebLabel15.SetParentComponent(WebPanel2);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 14;
    WebLabel15.Top := 544;
    WebLabel15.Width := 32;
    WebLabel15.Height := 13;
    WebLabel15.Caption := 'Other:';
    WebLabel15.HeightPercent := 100.000000000000000000;
    WebLabel15.WidthPercent := 100.000000000000000000;
    WebLabel16.SetParentComponent(WebPanel2);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 14;
    WebLabel16.Top := 393;
    WebLabel16.Width := 108;
    WebLabel16.Height := 13;
    WebLabel16.Caption := 'Sala de entrenamiento';
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(WebPanel2);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 174;
    WebLabel9.Top := 346;
    WebLabel9.Width := 67;
    WebLabel9.Height := 13;
    WebLabel9.Caption := 'Duraci'#243'n total';
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.Visible := False;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebLabel10.SetParentComponent(WebPanel2);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 222;
    WebLabel10.Top := 158;
    WebLabel10.Width := 41;
    WebLabel10.Height := 13;
    WebLabel10.Caption := 'Alcance:';
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebDBEdit4.SetParentComponent(WebPanel2);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 150;
    WebDBEdit4.Top := 271;
    WebDBEdit4.Width := 121;
    WebDBEdit4.Height := 22;
    WebDBEdit4.ChildOrder := 9;
    WebDBEdit4.HeightPercent := 100.000000000000000000;
    WebDBEdit4.Text := 'WebDBEdit3';
    WebDBEdit4.Visible := False;
    WebDBEdit4.WidthPercent := 100.000000000000000000;
    WebDBEdit4.DataField := 'FechaFin';
    WebDBEdit4.DataSource := DsSolicitudHdr;
    WebDBEdit1.SetParentComponent(WebPanel2);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 14;
    WebDBEdit1.Top := 177;
    WebDBEdit1.Width := 179;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 1;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.ReadOnly := True;
    WebDBEdit1.Text := 'WebDBEdit1';
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBEdit1, Self, 'OnEnter', 'WebDBEdit1Enter');
    WebDBEdit1.DataField := 'NoDocumento';
    WebDBEdit1.DataSource := DsSolicitudHdr;
    WebDBEdit2.SetParentComponent(WebPanel2);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 14;
    WebDBEdit2.Top := 224;
    WebDBEdit2.Width := 331;
    WebDBEdit2.Height := 22;
    WebDBEdit2.ChildOrder := 1;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.ReadOnly := True;
    WebDBEdit2.Text := 'WebDBEdit1';
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit2.DataField := 'DocumentoNombre';
    WebDBEdit2.DataSource := DsSolicitudHdr;
    WebDBEdit5.SetParentComponent(WebPanel2);
    WebDBEdit5.Name := 'WebDBEdit5';
    WebDBEdit5.Left := 14;
    WebDBEdit5.Top := 318;
    WebDBEdit5.Width := 115;
    WebDBEdit5.Height := 22;
    WebDBEdit5.ChildOrder := 1;
    WebDBEdit5.HeightPercent := 100.000000000000000000;
    WebDBEdit5.ReadOnly := True;
    WebDBEdit5.Text := 'WebDBEdit1';
    WebDBEdit5.WidthPercent := 100.000000000000000000;
    WebDBEdit5.DataField := 'Revision';
    WebDBEdit5.DataSource := DsSolicitudHdr;
    WebDBEdit6.SetParentComponent(WebPanel2);
    WebDBEdit6.Name := 'WebDBEdit6';
    WebDBEdit6.Left := 12;
    WebDBEdit6.Top := 365;
    WebDBEdit6.Width := 115;
    WebDBEdit6.Height := 22;
    WebDBEdit6.ChildOrder := 1;
    WebDBEdit6.HeightPercent := 100.000000000000000000;
    WebDBEdit6.Text := 'WebDBEdit1';
    WebDBEdit6.Visible := False;
    WebDBEdit6.WidthPercent := 100.000000000000000000;
    WebDBEdit6.DataField := 'Duracion';
    WebDBEdit6.DataSource := DsSolicitudHdr;
    WebSpeedButton4.SetParentComponent(WebPanel2);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 392;
    WebSpeedButton4.Top := 17;
    WebSpeedButton4.Width := 41;
    WebSpeedButton4.Height := 33;
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.Glyph.LoadFromFile('uSolicitudDwk.WebPanel2.WebSpeedButton4.Glyph.png');
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.Layout := blGlyphTop;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    WebSpeedButton5.SetParentComponent(WebPanel2);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 439;
    WebSpeedButton5.Top := 17;
    WebSpeedButton5.Width := 41;
    WebSpeedButton5.Height := 33;
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.Glyph.LoadFromFile('uSolicitudDwk.WebPanel2.WebSpeedButton5.Glyph.png');
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.Layout := blGlyphTop;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    WebDateTimePicker2.SetParentComponent(WebPanel2);
    WebDateTimePicker2.Name := 'WebDateTimePicker2';
    WebDateTimePicker2.Left := 210;
    WebDateTimePicker2.Top := 271;
    WebDateTimePicker2.Width := 61;
    WebDateTimePicker2.Height := 22;
    WebDateTimePicker2.HeightPercent := 100.000000000000000000;
    WebDateTimePicker2.WidthPercent := 100.000000000000000000;
    WebDateTimePicker2.BorderStyle := bsSingle;
    WebDateTimePicker2.ChildOrder := 10;
    WebDateTimePicker2.Color := clWhite;
    WebDateTimePicker2.Date := 46009.395262210650000000;
    WebDateTimePicker2.Role := '';
    WebDateTimePicker2.Text := '';
    WebDateTimePicker2.Visible := False;
    WebDBEdit3.SetParentComponent(WebPanel2);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 14;
    WebDBEdit3.Top := 271;
    WebDBEdit3.Width := 121;
    WebDBEdit3.Height := 22;
    WebDBEdit3.ChildOrder := 9;
    WebDBEdit3.HeightPercent := 100.000000000000000000;
    WebDBEdit3.Text := 'WebDBEdit3';
    WebDBEdit3.WidthPercent := 100.000000000000000000;
    WebDBEdit3.DataField := 'FechaPedido';
    WebDBEdit3.DataSource := DsSolicitudHdr;
    WebDateTimePicker1.SetParentComponent(WebPanel2);
    WebDateTimePicker1.Name := 'WebDateTimePicker1';
    WebDateTimePicker1.Left := 74;
    WebDateTimePicker1.Top := 271;
    WebDateTimePicker1.Width := 61;
    WebDateTimePicker1.Height := 22;
    WebDateTimePicker1.HeightPercent := 100.000000000000000000;
    WebDateTimePicker1.WidthPercent := 100.000000000000000000;
    WebDateTimePicker1.BorderStyle := bsSingle;
    WebDateTimePicker1.ChildOrder := 10;
    WebDateTimePicker1.Color := clWhite;
    WebDateTimePicker1.Date := 46009.395262210650000000;
    WebDateTimePicker1.Role := '';
    WebDateTimePicker1.Text := '';
    WebDateTimePicker1.Visible := False;
    SetEvent(WebDateTimePicker1, Self, 'OnEnter', 'WebDateTimePicker1Enter');
    WebDBEdit8.SetParentComponent(WebPanel2);
    WebDBEdit8.Name := 'WebDBEdit8';
    WebDBEdit8.Left := 14;
    WebDBEdit8.Top := 36;
    WebDBEdit8.Width := 179;
    WebDBEdit8.Height := 22;
    WebDBEdit8.ChildOrder := 1;
    WebDBEdit8.HeightPercent := 100.000000000000000000;
    WebDBEdit8.ReadOnly := True;
    WebDBEdit8.Text := 'WebDBEdit1';
    WebDBEdit8.WidthPercent := 100.000000000000000000;
    WebDBEdit8.DataField := 'Folio';
    WebDBEdit8.DataSource := DsSolicitudHdr;
    WebDBEdit9.SetParentComponent(WebPanel2);
    WebDBEdit9.Name := 'WebDBEdit9';
    WebDBEdit9.Left := 14;
    WebDBEdit9.Top := 83;
    WebDBEdit9.Width := 179;
    WebDBEdit9.Height := 22;
    WebDBEdit9.ChildOrder := 1;
    WebDBEdit9.HeightPercent := 100.000000000000000000;
    WebDBEdit9.Text := 'WebDBEdit1';
    WebDBEdit9.WidthPercent := 100.000000000000000000;
    WebDBEdit9.DataField := 'Nombre';
    WebDBEdit9.DataSource := DsSolicitudHdr;
    WebDBEdit10.SetParentComponent(WebPanel2);
    WebDBEdit10.Name := 'WebDBEdit10';
    WebDBEdit10.Left := 14;
    WebDBEdit10.Top := 130;
    WebDBEdit10.Width := 179;
    WebDBEdit10.Height := 22;
    WebDBEdit10.ChildOrder := 1;
    WebDBEdit10.HeightPercent := 100.000000000000000000;
    WebDBEdit10.Text := 'WebDBEdit1';
    WebDBEdit10.WidthPercent := 100.000000000000000000;
    WebDBEdit10.DataField := 'Nombre2';
    WebDBEdit10.DataSource := DsSolicitudHdr;
    WebDBEdit11.SetParentComponent(WebPanel2);
    WebDBEdit11.Name := 'WebDBEdit11';
    WebDBEdit11.Left := 210;
    WebDBEdit11.Top := 83;
    WebDBEdit11.Width := 179;
    WebDBEdit11.Height := 22;
    WebDBEdit11.ChildOrder := 1;
    WebDBEdit11.HeightPercent := 100.000000000000000000;
    WebDBEdit11.Text := 'WebDBEdit1';
    WebDBEdit11.WidthPercent := 100.000000000000000000;
    WebDBEdit11.DataField := 'Depto';
    WebDBEdit11.DataSource := DsSolicitudHdr;
    WebDBEdit12.SetParentComponent(WebPanel2);
    WebDBEdit12.Name := 'WebDBEdit12';
    WebDBEdit12.Left := 210;
    WebDBEdit12.Top := 130;
    WebDBEdit12.Width := 179;
    WebDBEdit12.Height := 22;
    WebDBEdit12.ChildOrder := 1;
    WebDBEdit12.HeightPercent := 100.000000000000000000;
    WebDBEdit12.Text := 'WebDBEdit1';
    WebDBEdit12.WidthPercent := 100.000000000000000000;
    WebDBEdit12.DataField := 'Depto2';
    WebDBEdit12.DataSource := DsSolicitudHdr;
    WebDBEdit13.SetParentComponent(WebPanel2);
    WebDBEdit13.Name := 'WebDBEdit13';
    WebDBEdit13.Left := 52;
    WebDBEdit13.Top := 540;
    WebDBEdit13.Width := 187;
    WebDBEdit13.Height := 22;
    WebDBEdit13.ChildOrder := 1;
    WebDBEdit13.HeightPercent := 100.000000000000000000;
    WebDBEdit13.Text := 'WebDBEdit1';
    WebDBEdit13.WidthPercent := 100.000000000000000000;
    WebDBEdit13.DataField := 'OnOther';
    WebDBEdit13.DataSource := DsSolicitudHdr;
    WebDBCheckBox1.SetParentComponent(WebPanel2);
    WebDBCheckBox1.Name := 'WebDBCheckBox1';
    WebDBCheckBox1.Left := 14;
    WebDBCheckBox1.Top := 701;
    WebDBCheckBox1.Width := 291;
    WebDBCheckBox1.Height := 22;
    WebDBCheckBox1.Caption := '    ENTRENAMIENTO FINALIZADO';
    WebDBCheckBox1.ChildOrder := 33;
    WebDBCheckBox1.Color := clNone;
    WebDBCheckBox1.Enabled := False;
    WebDBCheckBox1.Font.Charset := DEFAULT_CHARSET;
    WebDBCheckBox1.Font.Color := clWindowText;
    WebDBCheckBox1.Font.Height := -16;
    WebDBCheckBox1.Font.Name := 'Tahoma';
    WebDBCheckBox1.Font.Style := [];
    WebDBCheckBox1.HeightPercent := 100.000000000000000000;
    WebDBCheckBox1.ParentFont := False;
    WebDBCheckBox1.State := cbUnchecked;
    WebDBCheckBox1.Visible := False;
    WebDBCheckBox1.WidthPercent := 100.000000000000000000;
    WebDBCheckBox1.DataField := 'Cerrado';
    WebDBCheckBox1.DataSource := DsSolicitudHdr;
    WebCheckBox1.SetParentComponent(WebPanel2);
    WebCheckBox1.Name := 'WebCheckBox1';
    WebCheckBox1.Left := 14;
    WebCheckBox1.Top := 412;
    WebCheckBox1.Width := 113;
    WebCheckBox1.Height := 22;
    WebCheckBox1.Caption := '    Classroom';
    WebCheckBox1.ChildOrder := 39;
    WebCheckBox1.Color := clNone;
    WebCheckBox1.HeightPercent := 100.000000000000000000;
    WebCheckBox1.State := cbUnchecked;
    WebCheckBox1.WidthPercent := 100.000000000000000000;
    WebCheckBox2.SetParentComponent(WebPanel2);
    WebCheckBox2.Name := 'WebCheckBox2';
    WebCheckBox2.Left := 14;
    WebCheckBox2.Top := 432;
    WebCheckBox2.Width := 113;
    WebCheckBox2.Height := 22;
    WebCheckBox2.Caption := '    Demostration';
    WebCheckBox2.ChildOrder := 39;
    WebCheckBox2.Color := clNone;
    WebCheckBox2.HeightPercent := 100.000000000000000000;
    WebCheckBox2.State := cbUnchecked;
    WebCheckBox2.WidthPercent := 100.000000000000000000;
    WebCheckBox3.SetParentComponent(WebPanel2);
    WebCheckBox3.Name := 'WebCheckBox3';
    WebCheckBox3.Left := 14;
    WebCheckBox3.Top := 452;
    WebCheckBox3.Width := 113;
    WebCheckBox3.Height := 22;
    WebCheckBox3.Caption := '    On the job';
    WebCheckBox3.ChildOrder := 39;
    WebCheckBox3.Color := clNone;
    WebCheckBox3.HeightPercent := 100.000000000000000000;
    WebCheckBox3.State := cbUnchecked;
    WebCheckBox3.WidthPercent := 100.000000000000000000;
    WebCheckBox4.SetParentComponent(WebPanel2);
    WebCheckBox4.Name := 'WebCheckBox4';
    WebCheckBox4.Left := 14;
    WebCheckBox4.Top := 472;
    WebCheckBox4.Width := 113;
    WebCheckBox4.Height := 22;
    WebCheckBox4.Caption := '    Video';
    WebCheckBox4.ChildOrder := 39;
    WebCheckBox4.Color := clNone;
    WebCheckBox4.HeightPercent := 100.000000000000000000;
    WebCheckBox4.State := cbUnchecked;
    WebCheckBox4.WidthPercent := 100.000000000000000000;
    WebCheckBox5.SetParentComponent(WebPanel2);
    WebCheckBox5.Name := 'WebCheckBox5';
    WebCheckBox5.Left := 14;
    WebCheckBox5.Top := 492;
    WebCheckBox5.Width := 132;
    WebCheckBox5.Height := 22;
    WebCheckBox5.Caption := '    Semminars/Courses';
    WebCheckBox5.ChildOrder := 39;
    WebCheckBox5.Color := clNone;
    WebCheckBox5.HeightPercent := 100.000000000000000000;
    WebCheckBox5.State := cbUnchecked;
    WebCheckBox5.WidthPercent := 100.000000000000000000;
    WebCheckBox6.SetParentComponent(WebPanel2);
    WebCheckBox6.Name := 'WebCheckBox6';
    WebCheckBox6.Left := 14;
    WebCheckBox6.Top := 512;
    WebCheckBox6.Width := 155;
    WebCheckBox6.Height := 22;
    WebCheckBox6.Caption := '    Self study of company';
    WebCheckBox6.ChildOrder := 39;
    WebCheckBox6.Color := clNone;
    WebCheckBox6.HeightPercent := 100.000000000000000000;
    WebCheckBox6.State := cbUnchecked;
    WebCheckBox6.WidthPercent := 100.000000000000000000;
    WebDBEdit7.SetParentComponent(WebPanel2);
    WebDBEdit7.Name := 'WebDBEdit7';
    WebDBEdit7.Left := 172;
    WebDBEdit7.Top := 365;
    WebDBEdit7.Width := 115;
    WebDBEdit7.Height := 22;
    WebDBEdit7.ChildOrder := 1;
    WebDBEdit7.HeightPercent := 100.000000000000000000;
    WebDBEdit7.Text := 'WebDBEdit1';
    WebDBEdit7.Visible := False;
    WebDBEdit7.WidthPercent := 100.000000000000000000;
    WebDBEdit7.DataField := 'DuracionTotal';
    WebDBEdit7.DataSource := DsSolicitudHdr;
    WebDBEdit14.SetParentComponent(WebPanel2);
    WebDBEdit14.Name := 'WebDBEdit14';
    WebDBEdit14.Left := 222;
    WebDBEdit14.Top := 177;
    WebDBEdit14.Width := 227;
    WebDBEdit14.Height := 22;
    WebDBEdit14.ChildOrder := 1;
    WebDBEdit14.HeightPercent := 100.000000000000000000;
    WebDBEdit14.Text := 'WebDBEdit1';
    WebDBEdit14.WidthPercent := 100.000000000000000000;
    WebDBEdit14.DataField := 'Alcance';
    WebDBEdit14.DataSource := DsSolicitudHdr;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 530;
    WebPanel1.Top := 135;
    WebPanel1.Width := 354;
    WebPanel1.Height := 152;
    WebPanel1.HeightPercent := 100.000000000000000000;
    WebPanel1.WidthPercent := 100.000000000000000000;
    WebPanel1.BorderColor := clBlack;
    WebPanel1.BorderStyle := bsSingle;
    WebPanel1.ChildOrder := 1;
    WebPanel1.Color := clInfoBk;
    WebSpeedButton1.SetParentComponent(WebPanel1);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 14;
    WebSpeedButton1.Top := 17;
    WebSpeedButton1.Width := 235;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := '    Asignar empleados';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.Glyph.LoadFromFile('uSolicitudDwk.WebPanel1.WebSpeedButton1.Glyph.png');
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton13.SetParentComponent(WebPanel1);
    WebSpeedButton13.Name := 'WebSpeedButton13';
    WebSpeedButton13.Left := 97;
    WebSpeedButton13.Top := 55;
    WebSpeedButton13.Width := 152;
    WebSpeedButton13.Height := 24;
    WebSpeedButton13.Caption := '    Asignar depto masivo';
    WebSpeedButton13.Color := clNone;
    WebSpeedButton13.Glyph.LoadFromFile('uSolicitudDwk.WebPanel1.WebSpeedButton13.Glyph.png');
    WebSpeedButton13.HeightPercent := 100.000000000000000000;
    WebSpeedButton13.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton13, Self, 'OnClick', 'WebSpeedButton13Click');
    WebEdit3.SetParentComponent(WebPanel1);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 14;
    WebEdit3.Top := 55;
    WebEdit3.Width := 77;
    WebEdit3.Height := 22;
    WebEdit3.ChildOrder := 4;
    WebEdit3.HeightPercent := 100.000000000000000000;
    WebEdit3.WidthPercent := 100.000000000000000000;
    SetEvent(WebEdit3, Self, 'OnEnter', 'WebEdit3Enter');
    WebEdit6.SetParentComponent(WebPanel1);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 14;
    WebEdit6.Top := 85;
    WebEdit6.Width := 77;
    WebEdit6.Height := 22;
    WebEdit6.ChildOrder := 4;
    WebEdit6.HeightPercent := 100.000000000000000000;
    WebEdit6.WidthPercent := 100.000000000000000000;
    SetEvent(WebEdit6, Self, 'OnEnter', 'WebEdit6Enter');
    WebSpeedButton17.SetParentComponent(WebPanel1);
    WebSpeedButton17.Name := 'WebSpeedButton17';
    WebSpeedButton17.Left := 97;
    WebSpeedButton17.Top := 85;
    WebSpeedButton17.Width := 152;
    WebSpeedButton17.Height := 24;
    WebSpeedButton17.Caption := '    Asignar puesto masivo';
    WebSpeedButton17.Color := clNone;
    WebSpeedButton17.Glyph.LoadFromFile('uSolicitudDwk.WebPanel1.WebSpeedButton17.Glyph.png');
    WebSpeedButton17.HeightPercent := 100.000000000000000000;
    WebSpeedButton17.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton17, Self, 'OnClick', 'WebSpeedButton17Click');
    WebSpeedButton18.SetParentComponent(WebPanel1);
    WebSpeedButton18.Name := 'WebSpeedButton18';
    WebSpeedButton18.Left := 14;
    WebSpeedButton18.Top := 115;
    WebSpeedButton18.Width := 235;
    WebSpeedButton18.Height := 24;
    WebSpeedButton18.Caption := '    Asignar empleados masivo';
    WebSpeedButton18.Color := clNone;
    WebSpeedButton18.Glyph.LoadFromFile('uSolicitudDwk.WebPanel1.WebSpeedButton18.Glyph.png');
    WebSpeedButton18.HeightPercent := 100.000000000000000000;
    WebSpeedButton18.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton18, Self, 'OnClick', 'WebSpeedButton18Click');
    WebDBGrid1.SetParentComponent(Self);
    WebDBGrid1.Name := 'WebDBGrid1';
    WebDBGrid1.Left := 530;
    WebDBGrid1.Top := 293;
    WebDBGrid1.Width := 354;
    WebDBGrid1.Height := 500;
    WebDBGrid1.Columns.Clear;
    with WebDBGrid1.Columns.Add do
    begin
    end;
    with WebDBGrid1.Columns.Add do
    begin
    end;
    with WebDBGrid1.Columns.Add do
    begin
    end;
    with WebDBGrid1.Columns.Add do
    begin
    end;
    WebDBGrid1.DataSource := DsSolicitudDet;
    WebDBGrid1.FixedCols := 1;
    WebDBGrid1.TabOrder := 2;
    WebDBGrid1.HeightPercent := 100.000000000000000000;
    WebDBGrid1.WidthPercent := 100.000000000000000000;
    WebDBGrid1.ColWidths[0] := 24;
    WebDBGrid1.ColWidths[1] := 64;
    WebDBGrid1.ColWidths[2] := 64;
    WebDBGrid1.ColWidths[3] := 64;
    WebDBGrid1.ColWidths[4] := 64;
    WebPanel3.SetParentComponent(Self);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 16;
    WebPanel3.Top := 24;
    WebPanel3.Width := 497;
    WebPanel3.Height := 58;
    WebPanel3.HeightPercent := 100.000000000000000000;
    WebPanel3.WidthPercent := 100.000000000000000000;
    WebPanel3.BorderColor := clBlack;
    WebPanel3.BorderStyle := bsSingle;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clInfoBk;
    WebEdit2.SetParentComponent(WebPanel3);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 14;
    WebEdit2.Top := 19;
    WebEdit2.Width := 179;
    WebEdit2.Height := 22;
    WebEdit2.ChildOrder := 2;
    WebEdit2.HeightPercent := 100.000000000000000000;
    WebEdit2.WidthPercent := 100.000000000000000000;
    WebDBNavigator1.SetParentComponent(WebPanel3);
    WebDBNavigator1.Name := 'WebDBNavigator1';
    WebDBNavigator1.Left := 239;
    WebDBNavigator1.Top := 19;
    WebDBNavigator1.Width := 130;
    WebDBNavigator1.Height := 25;
    WebDBNavigator1.HeightPercent := 100.000000000000000000;
    WebDBNavigator1.WidthPercent := 100.000000000000000000;
    WebDBNavigator1.DataSource := DsSolicitudHdr;
    WebDBNavigator1.Hints.BeginUpdate;
    try
      WebDBNavigator1.Hints.Clear;
      WebDBNavigator1.Hints.Add('First');
      WebDBNavigator1.Hints.Add('Prior');
      WebDBNavigator1.Hints.Add('Next');
      WebDBNavigator1.Hints.Add('Last');
      WebDBNavigator1.Hints.Add('Edit');
      WebDBNavigator1.Hints.Add('Post');
      WebDBNavigator1.Hints.Add('Insert');
      WebDBNavigator1.Hints.Add('Delete');
      WebDBNavigator1.Hints.Add('Cancel');
    finally
      WebDBNavigator1.Hints.EndUpdate;
    end;
    WebDBNavigator1.VisibleButtons := [nbFirst,nbPrior,nbNext,nbLast];
    WebSpeedButton6.SetParentComponent(WebPanel3);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 199;
    WebSpeedButton6.Top := 19;
    WebSpeedButton6.Width := 24;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.Glyph.LoadFromFile('uSolicitudDwk.WebPanel3.WebSpeedButton6.Glyph.png');
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    WebSpeedButton2.SetParentComponent(Self);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 530;
    WebSpeedButton2.Top := 74;
    WebSpeedButton2.Width := 119;
    WebSpeedButton2.Height := 44;
    WebSpeedButton2.Caption := 'Editar';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.Glyph.LoadFromFile('uSolicitudDwk.WebSpeedButton2.Glyph.png');
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(Self);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 530;
    WebSpeedButton3.Top := 24;
    WebSpeedButton3.Width := 119;
    WebSpeedButton3.Height := 44;
    WebSpeedButton3.Caption := 'Agregar';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.Glyph.LoadFromFile('uSolicitudDwk.WebSpeedButton3.Glyph.png');
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebDBGrid2.SetParentComponent(Self);
    WebDBGrid2.Name := 'WebDBGrid2';
    WebDBGrid2.Left := 904;
    WebDBGrid2.Top := 43;
    WebDBGrid2.Width := 265;
    WebDBGrid2.Height := 809;
    WebDBGrid2.Columns.Clear;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Folio';
      Title := 'Folio';
      Width := 200;
    end;
    WebDBGrid2.DataSource := DsSolicitudHdr;
    WebDBGrid2.FixedCols := 1;
    WebDBGrid2.TabOrder := 7;
    WebDBGrid2.HeightPercent := 100.000000000000000000;
    WebDBGrid2.WidthPercent := 100.000000000000000000;
    WebDBGrid2.ColWidths[0] := 24;
    WebDBGrid2.ColWidths[1] := 200;
    WebPanel4.SetParentComponent(Self);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 1191;
    WebPanel4.Top := 88;
    WebPanel4.Width := 658;
    WebPanel4.Height := 326;
    WebPanel4.HeightPercent := 100.000000000000000000;
    WebPanel4.WidthPercent := 100.000000000000000000;
    WebPanel4.BorderColor := clSilver;
    WebPanel4.BorderStyle := bsSingle;
    WebPanel4.ChildOrder := 8;
    WebPanel4.Color := 11599792;
    WebPanel4.Visible := False;
    WebLabel18.SetParentComponent(WebPanel4);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 30;
    WebLabel18.Top := 27;
    WebLabel18.Width := 246;
    WebLabel18.Height := 13;
    WebLabel18.Caption := 'Busca documento (C'#243'digo/N'#250'mero del documento):';
    WebLabel18.HeightPercent := 100.000000000000000000;
    WebLabel18.WidthPercent := 100.000000000000000000;
    WebDBGrid3.SetParentComponent(WebPanel4);
    WebDBGrid3.Name := 'WebDBGrid3';
    WebDBGrid3.Left := 30;
    WebDBGrid3.Top := 79;
    WebDBGrid3.Width := 595;
    WebDBGrid3.Height := 214;
    WebDBGrid3.Columns.Clear;
    with WebDBGrid3.Columns.Add do
    begin
      DataField := 'Codigo';
      Title := 'Documento';
      Width := 150;
    end;
    with WebDBGrid3.Columns.Add do
    begin
      DataField := 'Descripcion';
      Title := 'Descripci'#243'n';
      Width := 350;
    end;
    WebDBGrid3.DataSource := DsEntrenaDoc;
    WebDBGrid3.FixedCols := 1;
    WebDBGrid3.TabOrder := 0;
    WebDBGrid3.HeightPercent := 100.000000000000000000;
    WebDBGrid3.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBGrid3, Self, 'OnDblClick', 'WebDBGrid3DblClick');
    WebDBGrid3.ColWidths[0] := 24;
    WebDBGrid3.ColWidths[1] := 150;
    WebDBGrid3.ColWidths[2] := 350;
    WebDBGrid3.RowHeights[0] := 22;
    WebDBGrid3.RowHeights[1] := 22;
    WebDBGrid3.RowHeights[2] := 22;
    WebDBGrid3.RowHeights[3] := 22;
    WebDBGrid3.RowHeights[4] := 22;
    WebEdit4.SetParentComponent(WebPanel4);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 30;
    WebEdit4.Top := 46;
    WebEdit4.Width := 196;
    WebEdit4.Height := 22;
    WebEdit4.ChildOrder := 4;
    WebEdit4.HeightPercent := 100.000000000000000000;
    WebEdit4.WidthPercent := 100.000000000000000000;
    WebSpeedButton8.SetParentComponent(WebPanel4);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 251;
    WebSpeedButton8.Top := 44;
    WebSpeedButton8.Width := 100;
    WebSpeedButton8.Height := 24;
    WebSpeedButton8.Caption := 'Buscar';
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.Glyph.LoadFromFile('uSolicitudDwk.WebPanel4.WebSpeedButton8.Glyph.png');
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton8, Self, 'OnClick', 'WebSpeedButton8Click');
    WebSpeedButton9.SetParentComponent(WebPanel4);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 365;
    WebSpeedButton9.Top := 44;
    WebSpeedButton9.Width := 100;
    WebSpeedButton9.Height := 24;
    WebSpeedButton9.Caption := 'Cancelar';
    WebSpeedButton9.Color := clNone;
    WebSpeedButton9.Glyph.LoadFromFile('uSolicitudDwk.WebPanel4.WebSpeedButton9.Glyph.png');
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton9, Self, 'OnClick', 'WebSpeedButton9Click');
    WebSpeedButton10.SetParentComponent(Self);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 1184;
    WebSpeedButton10.Top := 24;
    WebSpeedButton10.Width := 81;
    WebSpeedButton10.Height := 44;
    WebSpeedButton10.Caption := 'Salir';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.Glyph.LoadFromFile('uSolicitudDwk.WebSpeedButton10.Glyph.png');
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    WebSpeedButton11.SetParentComponent(Self);
    WebSpeedButton11.Name := 'WebSpeedButton11';
    WebSpeedButton11.Left := 655;
    WebSpeedButton11.Top := 24;
    WebSpeedButton11.Width := 119;
    WebSpeedButton11.Height := 44;
    WebSpeedButton11.Caption := 'Imprimir';
    WebSpeedButton11.Color := clNone;
    WebSpeedButton11.Glyph.LoadFromFile('uSolicitudDwk.WebSpeedButton11.Glyph.png');
    WebSpeedButton11.HeightPercent := 100.000000000000000000;
    WebSpeedButton11.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton11, Self, 'OnClick', 'WebSpeedButton11Click');
    WebPanel5.SetParentComponent(Self);
    WebPanel5.Name := 'WebPanel5';
    WebPanel5.Left := 1191;
    WebPanel5.Top := 439;
    WebPanel5.Width := 703;
    WebPanel5.Height := 326;
    WebPanel5.HeightPercent := 100.000000000000000000;
    WebPanel5.WidthPercent := 100.000000000000000000;
    WebPanel5.BorderColor := clSilver;
    WebPanel5.BorderStyle := bsSingle;
    WebPanel5.ChildOrder := 8;
    WebPanel5.Color := clSkyBlue;
    WebPanel5.Visible := False;
    WebLabel11.SetParentComponent(WebPanel5);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 30;
    WebLabel11.Top := 27;
    WebLabel11.Width := 81;
    WebLabel11.Height := 13;
    WebLabel11.Caption := 'Busca empleado:';
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebDBGrid4.SetParentComponent(WebPanel5);
    WebDBGrid4.Name := 'WebDBGrid4';
    WebDBGrid4.Left := 30;
    WebDBGrid4.Top := 79;
    WebDBGrid4.Width := 643;
    WebDBGrid4.Height := 214;
    WebDBGrid4.Columns.Clear;
    with WebDBGrid4.Columns.Add do
    begin
      DataField := 'Numero';
      Title := 'Numero';
      Width := 150;
    end;
    with WebDBGrid4.Columns.Add do
    begin
      DataField := 'Nombre';
      Title := 'Nombre';
      Width := 250;
    end;
    with WebDBGrid4.Columns.Add do
    begin
      DataField := 'Puesto';
      Title := 'Puesto';
      Width := 100;
    end;
    with WebDBGrid4.Columns.Add do
    begin
      DataField := 'Depto';
      Title := 'Depto';
      Width := 100;
    end;
    WebDBGrid4.DataSource := DsEmpleados;
    WebDBGrid4.FixedCols := 0;
    WebDBGrid4.TabOrder := 0;
    WebDBGrid4.HeightPercent := 100.000000000000000000;
    WebDBGrid4.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBGrid4, Self, 'OnDblClick', 'WebDBGrid4DblClick');
    WebDBGrid4.ColWidths[0] := 150;
    WebDBGrid4.ColWidths[1] := 250;
    WebDBGrid4.ColWidths[2] := 100;
    WebDBGrid4.ColWidths[3] := 100;
    WebDBGrid4.RowHeights[0] := 22;
    WebDBGrid4.RowHeights[1] := 22;
    WebDBGrid4.RowHeights[2] := 22;
    WebDBGrid4.RowHeights[3] := 22;
    WebDBGrid4.RowHeights[4] := 22;
    WebEdit1.SetParentComponent(WebPanel5);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 30;
    WebEdit1.Top := 46;
    WebEdit1.Width := 419;
    WebEdit1.Height := 22;
    WebEdit1.ChildOrder := 4;
    WebEdit1.HeightPercent := 100.000000000000000000;
    WebEdit1.WidthPercent := 100.000000000000000000;
    WebSpeedButton7.SetParentComponent(WebPanel5);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 467;
    WebSpeedButton7.Top := 44;
    WebSpeedButton7.Width := 100;
    WebSpeedButton7.Height := 24;
    WebSpeedButton7.Caption := 'Buscar';
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.Glyph.LoadFromFile('uSolicitudDwk.WebPanel5.WebSpeedButton7.Glyph.png');
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    WebSpeedButton12.SetParentComponent(WebPanel5);
    WebSpeedButton12.Name := 'WebSpeedButton12';
    WebSpeedButton12.Left := 573;
    WebSpeedButton12.Top := 44;
    WebSpeedButton12.Width := 100;
    WebSpeedButton12.Height := 24;
    WebSpeedButton12.Caption := 'Cancelar';
    WebSpeedButton12.Color := clNone;
    WebSpeedButton12.Glyph.LoadFromFile('uSolicitudDwk.WebPanel5.WebSpeedButton12.Glyph.png');
    WebSpeedButton12.HeightPercent := 100.000000000000000000;
    WebSpeedButton12.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton12, Self, 'OnClick', 'WebSpeedButton12Click');
    WebProgressBar1.SetParentComponent(Self);
    WebProgressBar1.Name := 'WebProgressBar1';
    WebProgressBar1.Left := 530;
    WebProgressBar1.Top := 830;
    WebProgressBar1.Width := 354;
    WebProgressBar1.Height := 26;
    WebProgressBar1.HeightPercent := 100.000000000000000000;
    WebProgressBar1.WidthPercent := 100.000000000000000000;
    WebProgressBar1.ChildOrder := 11;
    WebPanel6.SetParentComponent(Self);
    WebPanel6.Name := 'WebPanel6';
    WebPanel6.Left := 1191;
    WebPanel6.Top := 786;
    WebPanel6.Width := 658;
    WebPanel6.Height := 326;
    WebPanel6.HeightPercent := 100.000000000000000000;
    WebPanel6.WidthPercent := 100.000000000000000000;
    WebPanel6.BorderColor := clSilver;
    WebPanel6.BorderStyle := bsSingle;
    WebPanel6.ChildOrder := 8;
    WebPanel6.Color := clSkyBlue;
    WebPanel6.Visible := False;
    WebLabel19.SetParentComponent(WebPanel6);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 30;
    WebLabel19.Top := 27;
    WebLabel19.Width := 157;
    WebLabel19.Height := 13;
    WebLabel19.Caption := 'Busca n'#250'mero de departamento:';
    WebLabel19.HeightPercent := 100.000000000000000000;
    WebLabel19.WidthPercent := 100.000000000000000000;
    WebDBGrid5.SetParentComponent(WebPanel6);
    WebDBGrid5.Name := 'WebDBGrid5';
    WebDBGrid5.Left := 30;
    WebDBGrid5.Top := 79;
    WebDBGrid5.Width := 595;
    WebDBGrid5.Height := 214;
    WebDBGrid5.Columns.Clear;
    with WebDBGrid5.Columns.Add do
    begin
      DataField := 'Clave';
      Title := 'N'#250'mero';
      Width := 150;
    end;
    with WebDBGrid5.Columns.Add do
    begin
      DataField := 'Departamento';
      Title := 'Descripci'#243'n';
      Width := 350;
    end;
    WebDBGrid5.DataSource := DsDeptos;
    WebDBGrid5.FixedCols := 1;
    WebDBGrid5.TabOrder := 0;
    WebDBGrid5.HeightPercent := 100.000000000000000000;
    WebDBGrid5.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBGrid5, Self, 'OnDblClick', 'WebDBGrid5DblClick');
    WebDBGrid5.ColWidths[0] := 24;
    WebDBGrid5.ColWidths[1] := 150;
    WebDBGrid5.ColWidths[2] := 350;
    WebDBGrid5.RowHeights[0] := 22;
    WebDBGrid5.RowHeights[1] := 22;
    WebDBGrid5.RowHeights[2] := 22;
    WebDBGrid5.RowHeights[3] := 22;
    WebDBGrid5.RowHeights[4] := 22;
    WebEdit5.SetParentComponent(WebPanel6);
    WebEdit5.Name := 'WebEdit5';
    WebEdit5.Left := 30;
    WebEdit5.Top := 46;
    WebEdit5.Width := 196;
    WebEdit5.Height := 22;
    WebEdit5.ChildOrder := 4;
    WebEdit5.HeightPercent := 100.000000000000000000;
    WebEdit5.WidthPercent := 100.000000000000000000;
    WebSpeedButton14.SetParentComponent(WebPanel6);
    WebSpeedButton14.Name := 'WebSpeedButton14';
    WebSpeedButton14.Left := 251;
    WebSpeedButton14.Top := 44;
    WebSpeedButton14.Width := 100;
    WebSpeedButton14.Height := 24;
    WebSpeedButton14.Caption := 'Buscar';
    WebSpeedButton14.Color := clNone;
    WebSpeedButton14.Glyph.LoadFromFile('uSolicitudDwk.WebPanel6.WebSpeedButton14.Glyph.png');
    WebSpeedButton14.HeightPercent := 100.000000000000000000;
    WebSpeedButton14.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton14, Self, 'OnClick', 'WebSpeedButton14Click');
    WebSpeedButton15.SetParentComponent(WebPanel6);
    WebSpeedButton15.Name := 'WebSpeedButton15';
    WebSpeedButton15.Left := 365;
    WebSpeedButton15.Top := 44;
    WebSpeedButton15.Width := 100;
    WebSpeedButton15.Height := 24;
    WebSpeedButton15.Caption := 'Cancelar';
    WebSpeedButton15.Color := clNone;
    WebSpeedButton15.Glyph.LoadFromFile('uSolicitudDwk.WebPanel6.WebSpeedButton15.Glyph.png');
    WebSpeedButton15.HeightPercent := 100.000000000000000000;
    WebSpeedButton15.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton15, Self, 'OnClick', 'WebSpeedButton15Click');
    WebButton1.SetParentComponent(Self);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 530;
    WebButton1.Top := 799;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Borrar';
    WebButton1.ChildOrder := 14;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebSpeedButton16.SetParentComponent(Self);
    WebSpeedButton16.Name := 'WebSpeedButton16';
    WebSpeedButton16.Left := 655;
    WebSpeedButton16.Top := 74;
    WebSpeedButton16.Width := 119;
    WebSpeedButton16.Height := 44;
    WebSpeedButton16.Caption := 'Actualizar';
    WebSpeedButton16.Color := clNone;
    WebSpeedButton16.Glyph.LoadFromFile('uSolicitudDwk.WebSpeedButton16.Glyph.png');
    WebSpeedButton16.HeightPercent := 100.000000000000000000;
    WebSpeedButton16.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton16, Self, 'OnClick', 'WebSpeedButton16Click');
    WebPanel7.SetParentComponent(Self);
    WebPanel7.Name := 'WebPanel7';
    WebPanel7.Left := 1191;
    WebPanel7.Top := 879;
    WebPanel7.Width := 658;
    WebPanel7.Height := 326;
    WebPanel7.HeightPercent := 100.000000000000000000;
    WebPanel7.WidthPercent := 100.000000000000000000;
    WebPanel7.BorderColor := clSilver;
    WebPanel7.BorderStyle := bsSingle;
    WebPanel7.ChildOrder := 8;
    WebPanel7.Color := clSkyBlue;
    WebPanel7.Visible := False;
    WebLabel20.SetParentComponent(WebPanel7);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 30;
    WebLabel20.Top := 27;
    WebLabel20.Width := 122;
    WebLabel20.Height := 13;
    WebLabel20.Caption := 'Busca n'#250'mero de puesto:';
    WebLabel20.HeightPercent := 100.000000000000000000;
    WebLabel20.WidthPercent := 100.000000000000000000;
    WebDBGrid6.SetParentComponent(WebPanel7);
    WebDBGrid6.Name := 'WebDBGrid6';
    WebDBGrid6.Left := 30;
    WebDBGrid6.Top := 74;
    WebDBGrid6.Width := 595;
    WebDBGrid6.Height := 214;
    WebDBGrid6.Columns.Clear;
    with WebDBGrid6.Columns.Add do
    begin
      DataField := 'Clave';
      Title := 'N'#250'mero';
      Width := 150;
    end;
    with WebDBGrid6.Columns.Add do
    begin
      DataField := 'Puesto';
      Title := 'Descripci'#243'n';
      Width := 350;
    end;
    WebDBGrid6.DataSource := DsPuestos;
    WebDBGrid6.FixedCols := 1;
    WebDBGrid6.TabOrder := 0;
    WebDBGrid6.HeightPercent := 100.000000000000000000;
    WebDBGrid6.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBGrid6, Self, 'OnDblClick', 'WebDBGrid6DblClick');
    WebDBGrid6.ColWidths[0] := 24;
    WebDBGrid6.ColWidths[1] := 150;
    WebDBGrid6.ColWidths[2] := 350;
    WebDBGrid6.RowHeights[0] := 22;
    WebDBGrid6.RowHeights[1] := 22;
    WebDBGrid6.RowHeights[2] := 22;
    WebDBGrid6.RowHeights[3] := 22;
    WebDBGrid6.RowHeights[4] := 22;
    WebEdit7.SetParentComponent(WebPanel7);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 30;
    WebEdit7.Top := 46;
    WebEdit7.Width := 196;
    WebEdit7.Height := 22;
    WebEdit7.ChildOrder := 4;
    WebEdit7.HeightPercent := 100.000000000000000000;
    WebEdit7.WidthPercent := 100.000000000000000000;
    WebSpeedButton19.SetParentComponent(WebPanel7);
    WebSpeedButton19.Name := 'WebSpeedButton19';
    WebSpeedButton19.Left := 251;
    WebSpeedButton19.Top := 44;
    WebSpeedButton19.Width := 100;
    WebSpeedButton19.Height := 24;
    WebSpeedButton19.Caption := 'Buscar';
    WebSpeedButton19.Color := clNone;
    WebSpeedButton19.Glyph.LoadFromFile('uSolicitudDwk.WebPanel7.WebSpeedButton19.Glyph.png');
    WebSpeedButton19.HeightPercent := 100.000000000000000000;
    WebSpeedButton19.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton19, Self, 'OnClick', 'WebSpeedButton19Click');
    WebSpeedButton20.SetParentComponent(WebPanel7);
    WebSpeedButton20.Name := 'WebSpeedButton20';
    WebSpeedButton20.Left := 365;
    WebSpeedButton20.Top := 44;
    WebSpeedButton20.Width := 100;
    WebSpeedButton20.Height := 24;
    WebSpeedButton20.Caption := 'Cancelar';
    WebSpeedButton20.Color := clNone;
    WebSpeedButton20.Glyph.LoadFromFile('uSolicitudDwk.WebPanel7.WebSpeedButton20.Glyph.png');
    WebSpeedButton20.HeightPercent := 100.000000000000000000;
    WebSpeedButton20.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton20, Self, 'OnClick', 'WebSpeedButton20Click');
    CSolicitudHdr.SetParentComponent(Self);
    CSolicitudHdr.Name := 'CSolicitudHdr';
    CSolicitudHdr.Active := False;
    CSolicitudHdr.AfterConnect := CSolicitudHdrAfterConnect;
    CSolicitudHdr.Left := 680;
    CSolicitudHdr.Top := 32;
    TSolicitudHdr.SetParentComponent(Self);
    TSolicitudHdr.Name := 'TSolicitudHdr';
    TSolicitudHdr.Connection := CSolicitudHdr;
    TSolicitudHdr.Left := 744;
    TSolicitudHdr.Top := 32;
    DsSolicitudHdr.SetParentComponent(Self);
    DsSolicitudHdr.Name := 'DsSolicitudHdr';
    DsSolicitudHdr.DataSet := TSolicitudHdr;
    SetEvent(DsSolicitudHdr, Self, 'OnDataChange', 'DsSolicitudHdrDataChange');
    DsSolicitudHdr.Left := 816;
    DsSolicitudHdr.Top := 32;
    CSolicitudDet.SetParentComponent(Self);
    CSolicitudDet.Name := 'CSolicitudDet';
    CSolicitudDet.Active := False;
    CSolicitudDet.AfterConnect := CSolicitudDetAfterConnect;
    CSolicitudDet.Left := 680;
    CSolicitudDet.Top := 80;
    TSolicitudDet.SetParentComponent(Self);
    TSolicitudDet.Name := 'TSolicitudDet';
    TSolicitudDet.Connection := CSolicitudDet;
    TSolicitudDet.Left := 744;
    TSolicitudDet.Top := 80;
    DsSolicitudDet.SetParentComponent(Self);
    DsSolicitudDet.Name := 'DsSolicitudDet';
    DsSolicitudDet.DataSet := TSolicitudDet;
    DsSolicitudDet.Left := 816;
    DsSolicitudDet.Top := 80;
    CEntrenaDoc.SetParentComponent(Self);
    CEntrenaDoc.Name := 'CEntrenaDoc';
    CEntrenaDoc.Active := False;
    CEntrenaDoc.AfterConnect := CEntrenaDocAfterConnect;
    CEntrenaDoc.Left := 680;
    CEntrenaDoc.Top := 128;
    TEntrenaDoc.SetParentComponent(Self);
    TEntrenaDoc.Name := 'TEntrenaDoc';
    TEntrenaDoc.Connection := CEntrenaDoc;
    TEntrenaDoc.Left := 744;
    TEntrenaDoc.Top := 128;
    DsEntrenaDoc.SetParentComponent(Self);
    DsEntrenaDoc.Name := 'DsEntrenaDoc';
    DsEntrenaDoc.DataSet := TEntrenaDoc;
    DsEntrenaDoc.Left := 816;
    DsEntrenaDoc.Top := 128;
    CEmpleados.SetParentComponent(Self);
    CEmpleados.Name := 'CEmpleados';
    CEmpleados.Active := False;
    CEmpleados.AfterConnect := CEmpleadosAfterConnect;
    CEmpleados.Left := 680;
    CEmpleados.Top := 176;
    TEmpleados.SetParentComponent(Self);
    TEmpleados.Name := 'TEmpleados';
    TEmpleados.Connection := CEmpleados;
    TEmpleados.Left := 744;
    TEmpleados.Top := 176;
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Headers.BeginUpdate;
    try
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest1.Headers.EndUpdate;
    end;
    SetEvent(WebHttpRequest1, Self, 'OnResponse', 'WebHttpRequest1Response');
    WebHttpRequest1.Left := 584;
    WebHttpRequest1.Top := 112;
    DsEmpleados.SetParentComponent(Self);
    DsEmpleados.Name := 'DsEmpleados';
    DsEmpleados.DataSet := TEmpleados;
    DsEmpleados.Left := 816;
    DsEmpleados.Top := 176;
    CDeptos.SetParentComponent(Self);
    CDeptos.Name := 'CDeptos';
    CDeptos.Active := False;
    CDeptos.AfterConnect := CDeptosAfterConnect;
    CDeptos.Left := 680;
    CDeptos.Top := 224;
    TDeptos.SetParentComponent(Self);
    TDeptos.Name := 'TDeptos';
    TDeptos.Connection := CDeptos;
    TDeptos.Left := 744;
    TDeptos.Top := 224;
    DsDeptos.SetParentComponent(Self);
    DsDeptos.Name := 'DsDeptos';
    DsDeptos.DataSet := TDeptos;
    DsDeptos.Left := 816;
    DsDeptos.Top := 224;
    CPuestos.SetParentComponent(Self);
    CPuestos.Name := 'CPuestos';
    CPuestos.Active := False;
    CPuestos.AfterConnect := CPuestosAfterConnect;
    CPuestos.Left := 680;
    CPuestos.Top := 272;
    TPuestos.SetParentComponent(Self);
    TPuestos.Name := 'TPuestos';
    TPuestos.Connection := CPuestos;
    TPuestos.Left := 744;
    TPuestos.Top := 272;
    DsPuestos.SetParentComponent(Self);
    DsPuestos.Name := 'DsPuestos';
    DsPuestos.DataSet := TPuestos;
    DsPuestos.Left := 816;
    DsPuestos.Top := 272;
  finally
    WebLabel17.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebDBEdit5.AfterLoadDFMValues;
    WebDBEdit6.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebDateTimePicker2.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    WebDateTimePicker1.AfterLoadDFMValues;
    WebDBEdit8.AfterLoadDFMValues;
    WebDBEdit9.AfterLoadDFMValues;
    WebDBEdit10.AfterLoadDFMValues;
    WebDBEdit11.AfterLoadDFMValues;
    WebDBEdit12.AfterLoadDFMValues;
    WebDBEdit13.AfterLoadDFMValues;
    WebDBCheckBox1.AfterLoadDFMValues;
    WebCheckBox1.AfterLoadDFMValues;
    WebCheckBox2.AfterLoadDFMValues;
    WebCheckBox3.AfterLoadDFMValues;
    WebCheckBox4.AfterLoadDFMValues;
    WebCheckBox5.AfterLoadDFMValues;
    WebCheckBox6.AfterLoadDFMValues;
    WebDBEdit7.AfterLoadDFMValues;
    WebDBEdit14.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton13.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebSpeedButton17.AfterLoadDFMValues;
    WebSpeedButton18.AfterLoadDFMValues;
    WebDBGrid1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebDBNavigator1.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebDBGrid2.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebDBGrid3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebSpeedButton11.AfterLoadDFMValues;
    WebPanel5.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebDBGrid4.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    WebSpeedButton12.AfterLoadDFMValues;
    WebProgressBar1.AfterLoadDFMValues;
    WebPanel6.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebDBGrid5.AfterLoadDFMValues;
    WebEdit5.AfterLoadDFMValues;
    WebSpeedButton14.AfterLoadDFMValues;
    WebSpeedButton15.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebSpeedButton16.AfterLoadDFMValues;
    WebPanel7.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebDBGrid6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebSpeedButton19.AfterLoadDFMValues;
    WebSpeedButton20.AfterLoadDFMValues;
    CSolicitudHdr.AfterLoadDFMValues;
    TSolicitudHdr.AfterLoadDFMValues;
    DsSolicitudHdr.AfterLoadDFMValues;
    CSolicitudDet.AfterLoadDFMValues;
    TSolicitudDet.AfterLoadDFMValues;
    DsSolicitudDet.AfterLoadDFMValues;
    CEntrenaDoc.AfterLoadDFMValues;
    TEntrenaDoc.AfterLoadDFMValues;
    DsEntrenaDoc.AfterLoadDFMValues;
    CEmpleados.AfterLoadDFMValues;
    TEmpleados.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
    DsEmpleados.AfterLoadDFMValues;
    CDeptos.AfterLoadDFMValues;
    TDeptos.AfterLoadDFMValues;
    DsDeptos.AfterLoadDFMValues;
    CPuestos.AfterLoadDFMValues;
    TPuestos.AfterLoadDFMValues;
    DsPuestos.AfterLoadDFMValues;
  end;
end;

end.
